import * as React from "react";
import { Step, Question } from ".";

// The same questions as in the original Step1Page
const questions: Question[] = [
    {
        question: "Quelle est la règle d’or du tutorat ? ",
        answers: ["Faire les devoirs avec les élèves-athlètes. ", 
            "Donner la réponse en dernier recours. ", 
            "Donner la réponse aussitôt qu’un élève-athlète ne comprend pas son erreur. "],
        correctAnswer: 1,
        explanation: "Effectivement, il est important de donner la réponse en dernier recours. Il faut d’abord les faire raisonner, les questionner sur leur cheminement mental, les faire dessiner, etc. S’il n’arrive toujours pas à la réponse, à ce moment il peut être pertinent de décortiquer les étapes à réaliser pour arriver à la réponse et leur partager la réponse. "
    },
    {
        question: "Parmi les éléments suivants, lequel constitue le fondement essentiel d’une relation de tutorat efficace, tout en soutenant l’engagement de l’élève-athlète dans ses apprentissages ?",
        answers: ["La mise en place d’une structure claire et constante pour favoriser un cadre sécurisant.",
            "Le développement d’un lien de confiance permettant une communication ouverte et bienveillante.",
            "L’adoption d’une posture encourageante pour soutenir la motivation intrinsèque.",
            "Une combinaison cohérente de structure, de lien relationnel et d’encouragements adaptés aux besoins de l’élève-athlète."],
        correctAnswer: 3,
        explanation: "Une séance de tutorat efficace ne repose pas sur un seul facteur, mais sur l’interaction équilibrée entre la structure, la relation et le soutien motivationnel : La structure assure la clarté et la progression. Le lien de confiance favorise l’ouverture, l’engagement et la persévérance. L’encouragement alimente la motivation et la confiance en soi."
    }
];

export function Step4Page() {
    return (
        <Step
            stepNumber="4"
            title="Quatrième capsule"
            videoUrl={`${process.env.PUBLIC_URL}/assets/formation-videos/video4.mp4`}
            redirectURL="/formation/5"
            questions={questions}
        />
    );
} 